"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
const Button_1 = tslib_1.__importDefault(require("../button/Button"));
const SimpleTooltip_1 = tslib_1.__importDefault(require("../tooltip/SimpleTooltip"));
const SidebarFullscreenToggle = ({ isFullscreen, tooltip, onClick = noop_1.default }) => {
    const fullscreenIconClasses = (0, classnames_1.default)('rioglyph', isFullscreen ? 'rioglyph-resize-small' : 'rioglyph-resize-full');
    const button = ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ bsStyle: Button_1.default.MUTED, iconOnly: true, onClick: onClick, "data-testid": 'sidebarFullscreenToggle' }, { children: (0, jsx_runtime_1.jsx)("span", { className: fullscreenIconClasses }) })));
    if (tooltip) {
        return ((0, jsx_runtime_1.jsx)(SimpleTooltip_1.default, Object.assign({ content: tooltip, placement: 'bottom' }, { children: button })));
    }
    return button;
};
exports.default = SidebarFullscreenToggle;
